import map from 'lodash.map';
import React from 'react';
import SwiperCore, { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import {
  IBannersData, IBannersItem,
} from 'constants/types';
import Loader from 'components/Loader/Loader';
import get from 'lodash.get';
import { Wrap } from './BannersSliderMainStyles';
import BannersCard from '../card/BannersCard';

const settings = {
  spaceBetween: 24,
  slidesPerView: 1,
  slidesPerColumn: 1,
  slidesPerGroup: 1,
  autoplay: false,
  centeredSlides: false,
  pagination: {
    clickable: true,
  },
  watchSlidesVisibility: true,
  preloadImages: false,
  breakpoints: {
    768: {
      spaceBetween: 24,
      slidesPerView: 2,
      slidesPerColumn: 1,
      slidesPerGroup: 1,
    },
  },
};

// Interfaces
interface IBannersSliderMain {
  data: IBannersData
  loading?: boolean
}

// Swiper
SwiperCore.use([Pagination]);

// Component
const BannersSliderMain = (props: IBannersSliderMain) => {
  const { data = [], loading = false } = props;

  if (loading) {
    return (
      <Wrap>
        <Loader />
      </Wrap>
    );
  }
  if (Array.isArray(data) && JSON.stringify(data) && !loading) {
    return (
      <Wrap>
        <Swiper {...settings}>
          {map(data, (item: IBannersItem) => {
            const id = get(item, ['alias']);

            return (
              <SwiperSlide key={id}>
                <BannersCard
                  item={item}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </Wrap>
    );
  }
  return null;
};

export default BannersSliderMain;
